module.exports = __webpack_public_path__ + "img/card-franchaisors4.d2403ed3.svg";